
function WPLiveChatAriaFix() {
  let clicks = 0;
  let liveChatActive = false;
  const liveChatWindowOpenButton = document.querySelector('.open-live-chat-window');
  if ( liveChatWindowOpenButton === null ) return false;

  waitForElement("#wplc_hovercard").then(function(element) {
    const liveChatHovercardElement =  document.getElementById('wplc_hovercard');
    const liveChatOpenElement = document.getElementById('wp-live-chat-header');
    const liveChatLoginWindow = document.getElementById('wp-live-chat-2');
    const liveChatMessageWindow = document.getElementById('wp-live-chat-4');
    const wplcFirstMessageDuplicate = document.getElementById('wplc_first_message');

    if ( wplcFirstMessageDuplicate ) wplcFirstMessageDuplicate.id = 'wplc_first_message_duplicate';

    liveChatWindowOpenButton.classList.add('active');
    createAriaDialog(liveChatHovercardElement, 'Start Chat Dialog');

    applyLiveChatAriaFixes();

    waitForElement('#wp-live-chat-4').then(function(element) {
      createAriaDialog(element, 'Chat Window');
      // ariaTest();
      webChatListenerInit();
    });

    waitForElement('#wp-live-chat-2').then(function(element) {
      createAriaDialog(element, 'Chat Login Form');
    });

    waitForElement('#wplc_gdpr_end_chat_notice_container').then(function(element) {
      createAriaDialog(element, 'End Chat Notice');
    });

    liveChatWindowOpenButton.addEventListener('click', function(event) {
      event.preventDefault();

      if ( !clicks && !liveChatOpenElement.classList.contains('active') ) {
        clicks++;
        liveChatOpenElement.click();
      }

      if ( liveChatHovercardElement === null || liveChatOpenElement === null ) {
        window.alert('Live chat is temporarily offline. Please, try again in a few minutes.');
        return false;
      } else if ( liveChatMessageWindow !== null && isVisible(liveChatMessageWindow) ){
        liveChatMessageWindow.focus();
      } else if ( liveChatLoginWindow !== null && isVisible(liveChatLoginWindow) ){
        liveChatLoginWindow.focus();
      } else if ( isVisible(liveChatHovercardElement) ) {
        liveChatHovercardElement.focus();
      }
    });
  });
}

function createAriaDialog(element, label) {
  element.setAttribute('role', 'dialog');
  element.setAttribute('aria-label', label);
  element.setAttribute('tabindex', '0');
}

function isVisible(element) {
  return element.offsetWidth > 0;
}

function applyLiveChatAriaFixes() {
  applyLiveChatAriaFix();
}

function applyLiveChatAriaFix() {
  const chatLoginInputs = {
    text: [
      { id: 'wplc_name', label: 'name' },
      { id: 'wplc_email', label: 'email' },
      { id: 'wplc_message', label: 'message' }
    ],
    checkbox: [ { id: 'wplc_chat_gdpr_opt_in', label: false } ]
  }

  const chatWindowInputs = {
    text: [
      { id: 'wplc_chatmsg', label: 'chat message' }
    ]
  }

  formAriaTextInputFixes(chatLoginInputs.text, 'Chat Login Form');
  formAriaCheckboxInputFixes(chatLoginInputs.checkbox);
  formAriaTextInputFixes(chatWindowInputs.text, 'Chat Window');
}

function formAriaTextInputFixes(text, formTitleText) {
  let parentDiv = false;
  let textElements = [];

  text.forEach((text, i) => {
    const textElement = document.getElementById(text.id);

    if ( textElement !== null ) {
      textElements.push(textElement);
      if ( i === 0 ) {
        parentDiv = textElements[i].parentNode;
      }

      if ( textElements[i].getAttribute('type') !== 'hidden' ) {
        textElements[i].setAttribute('aria-required', 'true');
        addFormLabel(parentDiv, textElements[i], text.id, text.label);
      }
    }
  });
}

function formAriaCheckboxInputFixes(checkbox) {
  let checkboxElements = [];

  checkbox.forEach((checkbox, i) => {
    const checkboxElement = document.getElementById(checkbox.id);

    if ( checkboxElement !== null ) {
      checkboxElements.push(checkboxElement);
      checkboxElements[i].setAttribute('aria-required', 'true');
      // addLoginAriaValidationErrors(checkboxElements[i])
    }
  });
}

function addFormLabel(parentDiv, inputField, labelFor, labelText) {
  let label = createFormLabel(labelFor, labelText)
  parentDiv.insertBefore(label, inputField);
}

function createFormLabel(labelFor, labelText) {
  let newLabel = document.createElement('label');
  newLabel.setAttribute('for', labelFor);
  newLabel.innerHTML = `Enter your ${labelText}`;

  return newLabel;
}

// function addLoginAriaValidationErrors(formInput) {
//   formInput.addEventListener('focusout', function() {
//     if ( ( this.type === 'checkbox' && this.checked )
//       || ( this.type === 'text' && this.value ) ) {
//       this.setAttribute('aria-invalid', 'false');
//     } else {
//       this.setAttribute('aria-invalid', 'true');
//     }
//   });
// }

/* Copied from https://gist.githubusercontent.com/jwilson8767/db379026efcbd932f64382db4b02853e/raw/dd78af946202bfe22f860bbd6c396932d2dbc29d/es6-element-ready.js */
function waitForElement(selector) {
  return new Promise((resolve, reject) => {
    let el = document.querySelector(selector);
    if (el) {resolve(el);}

    new MutationObserver((mutationRecords, observer) => {
      // Query for elements matching the specified selector
      Array.from(document.querySelectorAll(selector)).forEach((element) => {
        resolve(element);
        //Once we have resolved we don't need the observer anymore.
        observer.disconnect();
      });
    })
    .observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  });
}

function webChatListenerInit() {
  const ariaLiveChatWindow = document.getElementById('aria-live-chat-window');
  const chatBox = document.getElementById('wplc_chatbox');

  function chatSubscriber(mutations) {
    mutations.forEach((mutation) => {
      const chatMessage = mutation.addedNodes && mutation.addedNodes.length
        ? mutation.addedNodes[0] : false;
      if ( !chatMessage ) return false;

      const chatMessageNode = chatMessage.getElementsByClassName('messageBody');
      if ( !chatMessageNode.length ) return false;

      const chatMessageCopy = chatMessageNode[0].cloneNode(true);
      const pTag = document.createElement('p');
      let messageSource = document.createTextNode('admin: ');

      if ( chatMessageCopy ) {
        if ( chatMessage.classList.contains('wplc-user-message') ) {
          messageSource = document.createTextNode('you: ');
        }

        chatMessageCopy.insertBefore(messageSource, chatMessageCopy.firstChild);
        pTag.appendChild(chatMessageCopy);
        chatMessageCopy.normalize();
        ariaLiveChatWindow.appendChild(pTag);
      }

    })
  }

  const chatObserver = new MutationObserver(chatSubscriber);

  chatObserver.observe(chatBox, { childList: true, subtree: true });
}

/* uncomment ariaTest() above to test aria message functionality */
function ariaTest() {
  const ariaLiveChatWindow = document.getElementById('aria-live-chat-window');
  const messages = [
    'this is one message',
    'this is another one',
    'here\'s a third',
    'now what?'
  ]

  function addAlertText(message) {
    const pTag = document.createElement('p');
    pTag.innerHTML = `alert ${message}`;

    ariaLiveChatWindow.appendChild(pTag);
  }


  messages.forEach((message) => {
    setTimeout(function() {
      addAlertText(message);
    }, 3000);

  })
}

export default WPLiveChatAriaFix;
// module.exports = {
//   init: init()
// }
